(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('PropriedadeCardsCtrl', PropriedadeCards);

  PropriedadeCards.$inject = [
    '$scope',
    '$timeout',
    'PropriedadesService',
    'TimeService',
    '$route',
    '$routeParams'
  ];

  // eslint-disable-next-line max-lines-per-function, max-params
  function PropriedadeCards($scope, $timeout, PropriedadesService, TimeService, $route, $routeParams) {
    const vm = this;
    let calledChange = false;
    const DEFAULT_HISTORY_PER_PAGE = 30;
    const NO_SIDEBAR = [
      'inseto',
      'anotacao',
      'invasora',
      'doenca',
      'nematoide',
      'inimigo_natural'
    ];

    //////////////////////////////////////////
    // Controller data
    vm.loading = false;
    vm.summary = null;
    vm.activities = null;
    vm.page = 0;
    vm.hasPage = true;
    vm.searching = false;

    //////////////////////////////////////////
    // Bindable methods
    vm.hasAnything = hasAnything;
    vm.hasSummary = hasSummary;
    vm.hasActivities = hasActivities;
    vm.shouldShowActivity = shouldShowActivity;
    vm.iconClasses = iconClasses;
    vm.activate = activate;
    vm.hasItemActive = hasItemActive;
    vm.loadActivities = loadActivities;
    vm.showActivityDate = showActivityDate;
    vm.activityDate = activityDate;
    vm.isUnread = isUnread;

    //////////////////////////////////////////
    // Function declarations

    function loadSummary() {
      vm.activities = null;

      PropriedadesService.summary($scope.filters).then(function(result) {
        vm.summary = result;
      })
        .finally(function() {
          vm.loading = false;
          $scope.$emit('stopLoading');
        });
    }

    function loadActivities() {
      vm.summary = null;

      if (!$scope.isHistorico || vm.hasPage) {
        vm.loading = true;
        const data = getActivitiesParams();
        const params = {};
        if ($scope.isHistorico) {
          resetMap();
          params.per_page = DEFAULT_HISTORY_PER_PAGE;
          params.page = ++vm.page;
        }

        PropriedadesService.activitiesPaginated({ data, params })
          .then(processLoadedActivities)
          .finally(() => {
            $timeout(() => {
              vm.loading = false;
              vm.searching = false;
            });
            $scope.$emit('stopLoading');
          });
      }
    }

    function processLoadedActivities(result) {
      if ($scope.isHistorico) {
        vm.activities = (vm.activities || []).concat(result.data);
        if (((result.pages || {}).pagination || {}).next > 0) {
          vm.hasPage = true;
        } else {
          vm.hasPage = false;
        }
      } else {
        vm.activities = result.data;
      }
    }

    function getCulturasPorGleba() {
      if ($scope.culturasPorGleba) {
        return Object.keys($scope.culturasPorGleba).reduce(function(group, key) {
          group[key] = $scope.culturasPorGleba[key].ids;
          return group;
        }, {});
      }
      return {};
    }

    function flatId(array) {
      return _.flatMap(array, 'id').join();
    }

    function getActivitiesParams() {
      const date = $scope.filters.date || (!$scope.isHistorico && new Date());
      const tipo = $scope.filters.tipos ? flatId($scope.filters.tipos) : _.get($scope.filters.operacao, 'id');
      const atividade = $scope.filters.culturas ? flatId($scope.filters.culturas) : _.get($scope.filters.cultura, 'id');
      const usuario = $scope.filters.usuarios ? flatId($scope.filters.usuarios) : _.get($scope.filters.usuario, 'id');
      const cultivar = _.get($scope.filters.cultivar, 'item_id');

      return activitiesParamsObject({ date, tipo, atividade, usuario, cultivar });
    }

    function activitiesParamsObject({ date, tipo, atividade, usuario, cultivar }) {
      return {
        usuario,
        gleba: _.get($scope.filters.gleba, 'id'),
        tipo,
        ocorrencia: _.get($scope.filters.ocorrencia, 'id'),
        atividade,
        data_inicial: (date && moment(date).format('Y-MM-DD')) || null,
        data_final: (date && moment(date).format('Y-MM-DD')) || null,
        culturas_por_gleba: getCulturasPorGleba(),
        search: $scope.filters.search || null,
        cultivar
      };
    }

    // TODO: Função que reseta oque n deveria
    function loadCorrectType() {
      vm.loading = true;
      $scope.$emit('startLoading');

      resetMap();
      if ($scope.filters.date || $scope.isHistorico) {
        loadActivities();
      } else {
        loadSummary();
      }
    }

    function hasAnything() {
      return vm.hasActivities() || vm.hasSummary();
    }

    function hasActivities() {
      return (vm.activities || []).length;
    }

    function hasSummary() {
      return vm.summary && vm.summary.length;
    }

    function shouldShowActivity(activity) {
      const hasNotifications = activity.notificacoes.length > 0;

      if (hasNotifications) {
        return true;
      }

      if (activity.gerais.produtividade || activity.gerais.stand || activity.tempo_visita.descricao) {
        return true;
      }

      return false;
    }

    function iconClasses(item) {
      const obj = {
        'item-active': item.active
      };
      if (item.situacao) {
        obj[`bg-${ item.situacao}`] = true;
      }
      return obj;
    }

    // eslint-disable-next-line complexity
    function activate(type, data) {
      const item = data.activity || data.summary;

      // Activity (old history)
      if (type === 'activity') {
        activateItem(item, data.stand);
      // Notification
      } else if (type === 'notification') {
        toggleItem(data.notification, item);
      // Resumo Stand
      } else if (type === 'standSummary') {
        toggleItem(data.stand, item, true);
      // Stand
      } else if (type === 'stand') {
        toggleItem(data.stand, item);
      // Produtividade
      } else if (type === 'productivity') {
        toggleItem(data.productivity, item);
      // Resumo Produtividade
      } else if (type === 'produtividadeSummary') {
        toggleItem(data.productivity, item, true);
      // Tarefas
      } else if (type === 'tasks') {
        toggleItem(item, {});
      // Recomendações
      } else if (type === 'recommendations') {
        toggleItem(item, {});
      }
      updateRoute(type, data);
    }

    function activateItem(item, stand) {
      if (!hasActiveNotification(item.notificacoes) &&
          !hasActiveStand(item.gerais.stand, stand) &&
          !hasActiveProductivity(item.gerais.produtividade) &&
          !vm.hasItemActive(item.gerais.stand) &&
          item.active) {
        item.active = false;
      } else {
        deactivateActivities();
        item.active = true;
      }
    }

    function hasActiveNotification(notifications) {
      return _.some(notifications, 'active');
    }

    function hasActiveStand(stands, stand) {
      return _.some(stands, 'active') || (stand && stand.active);
    }

    function hasActiveProductivity(prods) {
      return _.some(prods, 'active');
    }

    function deactivateActivities() {
      (vm.activities || []).concat(vm.summary || []).forEach(function(item) {
        item.active = false;
        if (item.stand) {
          deactivateStands(item.gerais.stand);
        }
        if (_.get(item.notificacoes, 'length', 0) > 0) {
          deactivateNotifications(item.notificacoes);
        }
        if (_.get(item.gerais.stand, 'length', 0) > 0) {
          deactivateStands(item.gerais.stand);
        }
        if (_.get(item.gerais.produtividade, 'length', 0) > 0) {
          deactivateProductivities(item.gerais.produtividade);
        }
      });
    }

    function deactivateNotifications(notifications) {
      notifications.forEach(function(notification) {
        notification.active = false;
      });
    }

    function deactivateStands(stands) {
      stands.forEach(function(stand) {
        stand.active = false;
      });
    }

    function deactivateProductivities(productivities) {
      productivities.forEach(function(productivity) {
        productivity.active = false;
      });
    }

    function toggleItem(item, activity, isSummary = false) {
      if (item.active) {
        item.active = false;

        if (isSummary) {
          activity.active = false;
        }
      } else {
        deactivateActivities();
        activity.active = true;
        item.active = true;
      }
    }

    function hasItemActive(items) {
      return _.some(items, 'active');
    }

    function equals(item1, item2) {
      return JSON.stringify(item1) === JSON.stringify(item2);
    }

    // TODO: rever eslint
    // eslint-disable-next-line complexity, max-lines-per-function
    function updateRoute(type, data) {
      const shouldNotActivate = getShouldNotActivate(data);
      let activeGleba = null;
      const sidebar = shouldNotActivate === false ? getSidebar(type, data) : null;
      const standSummary = shouldNotActivate === false ? getSummaryStandIndex(type, data) : null;
      const produtividadeSummary = shouldNotActivate === false ? getSummaryProductivityIndex(type, data) : null;
      const notification = getNotificationType(type, data);
      const activeTab = shouldNotActivate === false ? getActiveTab(type, data) : null;
      let historyDate = null;

      if (data.activity && data.activity.active) {
        activeGleba = data.activity.gleba.id;

        if ($scope.isHistorico) {
          historyDate = data.activity.data;
        }
      }
      if (data.summary && data.summary.active) {
        activeGleba = data.summary.id;
      }

      if (sidebar) {
        $scope.$emit('setSidebarData', data);
      }

      $route.updateParams({
        sidebar,
        activeGleba,
        standSummary,
        produtividadeSummary,
        notification,
        activeTab,
        historyDate,
        recommendationFilters: null
      });
    }

    function getShouldNotActivate(data) {
      return NO_SIDEBAR.includes((data.notification || {}).tipo) ||
        ((data.notification || {}).tipo || '').includes('afericao') ||
        TIPOS_OUTRAS_OCORRENCIAS.includes((data.notification || {}).tipo);
    }

    // TODO: rever eslint
    // eslint-disable-next-line complexity, max-lines-per-function
    function getSidebar(type, data) {
      let sidebar = type;
      if (type === 'notification') {
        sidebar = data.notification.tipo;
      }

      switch (sidebar) {
      case 'stand':
        if (data.notification.active) {
          sidebar = 'standSummary';
        } else {
          sidebar = null;
        }
        break;
      case 'produtividade':
        if (data.notification.active) {
          sidebar = 'produtividadeSummary';
        } else {
          sidebar = null;
        }
        break;
      case 'summaryStand':
      case 'standSummary':
        if ((data.summary && data.summary.active) ||
          hasActiveStand((data.activity || data.summary).gerais.stand, data.stand)) {
          sidebar = 'standSummary';
        } else {
          sidebar = null;
        }
        break;
      case 'produtividadeSummary':
        if ((data.summary && data.summary.active) ||
          hasActiveProductivity((data.activity || data.summary).gerais.produtividade)) {
          sidebar = 'produtividadeSummary';
        } else {
          sidebar = null;
        }
        break;
      case 'operacao_adubacao':
      case 'operacao_correcao_solo':
      case 'aplicacao':
      case 'aplicacao_semeadura':
      case 'tratamento_semente':
        if (data.notification.active) {
          sidebar = 'applications';
        } else {
          sidebar = null;
        }
        break;
      case 'recommendations':
      case 'recomendacao':
      case 'recomendacao_operacao_correcao_solo':
      case 'recomendacao_operacao_adubacao':
        if ((data.notification || data.summary).active) {
          sidebar = 'recommendations';
        } else {
          sidebar = null;
        }
        break;
      case 'tarefa':
      case 'tasks':
        if ((data.notification || data.summary || data.activity).active) {
          sidebar = 'tasks';
        } else {
          sidebar = null;
        }
        break;
      case 'activity':
        sidebar = null;
        break;
      }

      return sidebar;
    }

    function getSummaryStandIndex(type, data) {
      const hasStandActive = (data.stand || {}).active && (data.activity || data.summary);
      if (type === 'standSummary' && hasStandActive) {
        return (data.activity || data.summary).gerais.stand.indexOf(data.stand);
      }
      return null;
    }

    function getSummaryProductivityIndex(type, data) {
      const hasProductivityActive = (data.productivity || {}).active && (data.activity || data.summary);
      if (type === 'produtividadeSummary' && hasProductivityActive) {
        return (data.activity || data.summary).gerais.produtividade.indexOf(data.productivity);
      }
      return null;
    }

    function getNotificationType(type, data) {
      if (type === 'notification' && (data.notification || {}).active) {
        return data.notification.tipo;
      }
      return null;
    }

    // TODO: rever eslint
    // eslint-disable-next-line complexity
    function getActiveTab(type, data) {
      let activeTab = null;

      if ((data.notification || {}).active) {
        switch (data.notification.tipo) {
        case 'recomendacao_operacao_adubacao':
        case 'operacao_adubacao':
          activeTab = 'adubacao';
          break;
        case 'recomendacao_operacao_correcao_solo':
        case 'operacao_correcao_solo':
          activeTab = 'correcaoSolo';
          break;
        case 'aplicacao_semeadura':
          activeTab = 'plantio';
          break;
        case 'tratamento_semente':
          activeTab = 'ts';
          break;
        case 'tarefa':
          activeTab = null;
          break;
        case 'operacao_pulverizacao':
          activeTab = 'pulverizacao';
          break;
        }
      }

      return activeTab;
    }

    function showActivityDate(index, activity) {
      let result = $scope.isHistorico;

      if (result) {
        result = vm.shouldShowActivity(activity);
      }

      if (result && index > 0) {
        result = vm.activities[index].data !== vm.activities[index - 1].data;
      }

      return result;
    }

    function activityDate(date) {
      date = moment(date);
      let result = `${date.format('DD')} de ${date.format('MMMM')}`;
      if (date.year() !== moment().year()) {
        result += ` / ${date.format('YYYY')}`;
      }
      return result;
    }

    function resetMap() {
      deactivateActivities();
      $scope.$emit('clearMarkers');
      $scope.$emit('setFocusedGleba', null);
      $scope.$emit('activateSidebar', null);
      $scope.$emit('clearPolygons');
      $scope.$emit('clearPolylines');
      $scope.$emit('setImageOverlays', []);
      $route.updateParams({
        activeGleba: $scope.isHistorico ? null : $routeParams.activeGleba,
        historyDate: null,
        sidebar: $scope.isHistorico ? null : $routeParams.sidebar,
        notification: $scope.isHistorico ? null : $routeParams.notification
      });
    }

    function isUnread(activity) {
      return $scope.isHistorico &&
        $scope.unreadHistories.some((unread) => (
          moment(unread.created_at).format(MOMENT_DATE_ENGLISH_FORMAT) === activity.data &&
            unread.gleba.id === activity.gleba.id
        ));
    }

    //////////////////////////////////////////
    // Controller logic

    $scope.$watch('culturasPorGleba', function(newVal, oldVal) {
      if (!equals(newVal, oldVal) || (!calledChange && newVal)) {
        calledChange = true;

        loadCorrectType();
      } else if (!newVal) {
        vm.summary = null;
        vm.activities = null;
      }
    });

    $scope.$watch('filters', function(newVal, oldVal) {
      if (!equals(newVal, oldVal)) {
        if (typeof newVal.search !== 'undefined') {
          vm.activities = null;
          vm.searching = true;
          vm.hasPage = true;
          vm.page = 0;
        }
        loadCorrectType();
      }
    }, true);

    $scope.$on('showHistoryTab', resetMap);
    $scope.$on('$destroy', resetMap);
  }
}());
